import React from 'react';
import Button from '../Base';
import ButtonContainer from './style';
const Index = (props) => {
  return <Button {...props} ButtonContainer={ButtonContainer} />;
};

export default Index;
